export default __webpack_public_path__ + "static/media/100-assurance.f4575481.svg";